export default {
    gd: window.gdSdkEnabled,
    version: "1.0.0",
    target: "Web"
}